import { useMutation, useQuery } from '@tanstack/react-query';
import {
  commonAxiosError,
  commonAxiosSuccess,
  queryClient,
} from '../../../Utils/TanstackQuery/queryClient';
import { httpService } from '../../../Helpers/Fetcher/axios';
import { visitorApi } from './constantVisitor';
import {
  ITicketingList,
  IVisitorInvoice,
  TVisitorSingleInvoice,
  VisitorFairEvent,
  VisitorServiceList,
} from './visitorType';
import { IVisitorUser } from '../../../Types/VisitorAuthTypes';
import { useNavigate } from 'react-router-dom';

/* VISITOR INVOICE */
export const useGetVisitorInvoiceList = () => {
  return useQuery({
    queryKey: [visitorApi.GET_VISITOR_INVOICE],
    queryFn: () =>
      httpService.get<IVisitorInvoice[]>({
        url: visitorApi.GET_VISITOR_INVOICE,
      }),
  });
};

export const useViewVisitorSingleInvoice = (id: string) => {
  return useQuery({
    queryKey: [visitorApi.GET_VISITOR_INVOICE, id],
    queryFn: () =>
      httpService.get<TVisitorSingleInvoice>({
        url: `${visitorApi.GET_VISITOR_INVOICE}/${id}`,
      }),
  });
};
export const useDeleteVisitorEvent = () => {
  return useMutation({
    mutationFn: (id: number) =>
      httpService.delete({ url: `${visitorApi.DELETE_VISITOR_EVENT}/${id}` }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully deleted!`);
      queryClient.invalidateQueries({
        queryKey: [visitorApi.GET_VISITOR_EVENT],
      });
    },
  });
};

export const useGetVisitorEventList = () => {
  return useQuery({
    queryKey: [visitorApi.GET_VISITOR_EVENT],
    queryFn: () =>
      httpService.get<VisitorFairEvent[]>({
        url: visitorApi.GET_VISITOR_EVENT,
      }),
  });
};

export const useGetVisitorProfileData = () => {
  return useQuery({
    queryKey: [visitorApi.GET_VISITOR_PROFILE_DATA],
    queryFn: () =>
      httpService.get<IVisitorUser>({
        url: visitorApi.GET_VISITOR_PROFILE_DATA,
      }),
  });
};

export const useVisitorProfileUpdate = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (data: FormData) =>
      httpService.patch({
        url: `${visitorApi.VISITOR_PROFILE_DATA_UPDATE}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Updated!`);
      queryClient.invalidateQueries({
        queryKey: [visitorApi.GET_VISITOR_PROFILE_DATA],
      });
      navigate('/visitor/profile');
    },
    onError: commonAxiosError(),
  });
};

/* ticketing request--------------------------- */

export const useCreateTicketingRequest = () => {
  return useMutation({
    mutationFn: (
      data: { service_id: number; quantity: number; date: string }[]
    ) =>
      httpService.post<{ invoice_id: number }, {}>({
        url: `${visitorApi.CREATE_TICKETING_REQUEST}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Created!`);
      const queryKeys = [
        visitorApi.GET_ALL_TICKETING_REQUEST,
        visitorApi.GET_VISITOR_INVOICE,
      ];

      queryKeys.map((queryKey) => {
        queryClient.invalidateQueries({ queryKey: [queryKey] });
      });
    },
    onError: commonAxiosError(),
  });
};

export const useGetTicketServiceList = () => {
  return useQuery({
    queryKey: [visitorApi.TICKETING_SERVICE_LIST],
    queryFn: () =>
      httpService.get<VisitorServiceList[]>({
        url: visitorApi.TICKETING_SERVICE_LIST,
      }),
  });
};

export const useGetAllTicketingList = () => {
  return useQuery({
    queryKey: [visitorApi.GET_ALL_TICKETING_REQUEST],
    queryFn: () =>
      httpService.get<ITicketingList[]>({
        url: visitorApi.GET_ALL_TICKETING_REQUEST,
      }),
  });
};
export const useDeleteTicketingRequest = () => {
  return useMutation({
    mutationFn: (id: number) =>
      httpService.delete({
        url: `${visitorApi.DELETE_TICKETING_REQUEST}/${id}`,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Deleted!`);
      queryClient.invalidateQueries({
        queryKey: [visitorApi.GET_ALL_TICKETING_REQUEST],
      });
    },
    onError: commonAxiosError(),
  });
};
